import React from "react"
import { Col, Row, Button, TabPane, Card, CardBody } from "reactstrap"

const CPSTypeTab = ({ nextTab, request, setRequest }) => {
  const handleTypeSelection = type => {
    if (!request.isSubRequest) {
      setRequest({ ...request, type: type })
    }
  }

  const canProceed = request.type !== ""

  return (
    <TabPane tabId={1}>
      <div>
        <div className="text-center mb-4">
          <h5 className="card-title">Select CPS Service Type</h5>
          <p className="card-title-desc">
            Choose the type of service you need for your PCBs
          </p>
          {request.isSubRequest && (
            <div className="alert alert-info">
              <i className="bx bx-info-circle me-2"></i>
              This is a sub-request for parent request{" "}
              <strong>{request.parentRequestNumber}</strong>. Type is locked to{" "}
              <strong>Programming</strong>.
            </div>
          )}
        </div>

        <Row className="justify-content-center">
          <Col lg="10">
            <Row>
              <Col md="6" className="mb-3">
                <Card
                  className={`text-center h-100 ${
                    request.type === "Programming"
                      ? "border-primary bg-soft-primary"
                      : ""
                  } ${request.isSubRequest ? "opacity-75" : ""}`}
                  style={{
                    cursor: request.isSubRequest ? "not-allowed" : "pointer",
                  }}
                  onClick={() => handleTypeSelection("Programming")}
                >
                  <CardBody className="p-4">
                    <div className="avatar-sm mx-auto mb-4">
                      <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-16">
                        <i className="bx bx-microchip"></i>
                      </span>
                    </div>
                    <h5 className="font-size-16 mb-1">PCB Programming</h5>
                    <p className="text-muted mb-2">
                      Microcontroller and FPGA programming services
                    </p>
                    <ul className="list-unstyled text-muted mb-0">
                      <li>
                        <i className="mdi mdi-check text-success me-2"></i>
                        Firmware Upload
                      </li>
                      <li>
                        <i className="mdi mdi-check text-success me-2"></i>
                        Configuration Setting
                      </li>
                      <li>
                        <i className="mdi mdi-check text-success me-2"></i>
                        Testing & Verification
                      </li>
                      <li>
                        <i className="mdi mdi-check text-success me-2"></i>
                        Programming Protocols
                      </li>
                    </ul>
                  </CardBody>
                </Card>
              </Col>

              <Col md="6" className="mb-3">
                <Card
                  className={`text-center h-100 ${
                    request.type === "Sleeving"
                      ? "border-primary bg-soft-primary"
                      : ""
                  }`}
                  style={{ cursor: "pointer" }}
                  onClick={() => handleTypeSelection("Sleeving")}
                >
                  <CardBody className="p-4">
                    <div className="avatar-sm mx-auto mb-4">
                      <span className="avatar-title rounded-circle bg-info bg-soft text-info font-size-16">
                        <i className="bx bx-package"></i>
                      </span>
                    </div>
                    <h5 className="font-size-16 mb-1">PCB Sleeving</h5>
                    <p className="text-muted mb-2">
                      Professional PCB packaging and sleeving services
                    </p>
                    <ul className="list-unstyled text-muted mb-0">
                      <li>
                        <i className="mdi mdi-check text-success me-2"></i>Tape
                        & Reel
                      </li>
                      <li>
                        <i className="mdi mdi-check text-success me-2"></i>
                        Custom Packaging
                      </li>
                      <li>
                        <i className="mdi mdi-check text-success me-2"></i>
                        Anti-Static Protection
                      </li>
                      <li>
                        <i className="mdi mdi-check text-success me-2"></i>
                        Labeling Services
                      </li>
                    </ul>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            {request.type && (
              <div className="mt-4 p-3 bg-light rounded">
                <div className="d-flex align-items-center">
                  <i className="bx bx-check-circle text-success font-size-18 me-2"></i>
                  <span className="fw-medium">Selected: {request.type}</span>
                </div>
              </div>
            )}
          </Col>
        </Row>
      </div>

      <div className="d-flex justify-content-between mt-4">
        <Button color="secondary" disabled>
          Previous
        </Button>
        <Button
          color="primary"
          onClick={() => nextTab(1)}
          disabled={!canProceed}
        >
          Next - Request Data
        </Button>
      </div>
    </TabPane>
  )
}

export default CPSTypeTab
